module.exports = __webpack_public_path__ + "static/media/Edit-Grey.8a12824d.svg";